if (!customElements.get("popup-overlay")) {
  customElements.define(
    "popup-overlay",
    class PopupOverlay extends ModalDialog {
      constructor() {
        super();
        this.delay = parseInt(this.dataset.delay, 10) * 1000;
        this.reshowDays = parseInt(this.dataset.reshowDays || "0", 10);
        this.exitIntent = this.dataset.exitIntent === "true";
        this.id = this.getAttribute("id");
        this.moved = true;
        this.querySelectorAll("[data-popup-dismiss]").forEach((button) => {
          button.addEventListener("click", this.hide.bind(this));
        });
      }

      connectedCallback() {
        if (!Shopify.designMode && this.shouldShow()) {
          setTimeout(() => {
            this.open();
          }, this.remainingDelay());

          if (this.exitIntent && window.matchMedia("(pointer: fine)").matches) {
            document.documentElement.addEventListener("mouseleave", (event) => {
              if (event.clientY <= 0 && performance.now() > 5000) {
                this.open();
              }
            });
          }
        }

        return super.connectedCallback();
      }

      // Stan w localStorage: "dismissed" = zapisany (nie pokazujemy nigdy),
      // "closed:<czas>" = zamknięty (wraca po reshowDays dniach, 0 = nigdy).
      shouldShow() {
        if (/[?&]utm_medium=email(&|$)/.test(window.location.search)) {
          // Wejście z naszego newslettera – ta osoba już jest zapisana.
          this.remember("dismissed");
          return false;
        }

        const state = this.storedState();
        if (state === "dismissed") {
          return false;
        }

        if (state && state.startsWith("closed:")) {
          const closedAt = parseInt(state.slice(7), 10);
          return this.reshowDays > 0 && Date.now() - closedAt > this.reshowDays * 86400000;
        }

        return true;
      }

      // Opóźnienie liczone od początku wizyty, a nie od wejścia na bieżącą podstronę.
      remainingDelay() {
        let start = Date.now();
        try {
          start = parseInt(sessionStorage.getItem("popup-overlay-visit-start"), 10) || start;
          sessionStorage.setItem("popup-overlay-visit-start", start);
        } catch (e) {}

        return Math.max(this.delay - (Date.now() - start), Math.min(this.delay, 3000));
      }

      storedState() {
        try {
          return localStorage.getItem(this.id);
        } catch (e) {
          return null;
        }
      }

      remember(state) {
        try {
          localStorage.setItem(this.id, state);
        } catch (e) {}
      }

      open() {
        if (this.opened) {
          return;
        }

        this.opened = true;
        this.show();
      }

      show() {
        super.show();
        document.body.classList.remove("overflow-hidden");
        const event = new CustomEvent("popup-overlay:open", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
      }

      hide() {
        super.hide();
        const event = new CustomEvent("popup-overlay:close", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);

        if (!Shopify.designMode && this.storedState() !== "dismissed") {
          this.remember("closed:" + Date.now());
        }
      }
    },
  );
}
